export const Pagination = {
  pageNumber: 1,
  pageSize: 10,
};
